import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const groupService = {
  create: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.CREATE_GROUP,
        method: 'POST',
        data:  data ,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Create group error:', error);
      throw error;
    }
  },
  getAllGroups: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_GROUPS,
        method: 'POST',
        data: { companyId: '0' },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get all groups error:', error);
      throw error;
    }
  },
  getById: async (groupId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_BY_ID_GROUP,
        method: 'POST',
        data: { groupId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get group by ID error:', error);
      throw error;
    }
  },
  update: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.UPDATE_GROUP}`,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update group error:', error);
      throw error;
    }
  },

  delete: async (groupId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_GROUP,
        method: 'POST',
        data: { groupId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete group error:', error);
      throw error;
    }
  },
};
